import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { _ } from '_locales';
import { connect } from 'react-redux';
import { goToTop } from '_helpers';
import RFDetails from './components/RFDetails';
import RFCarousel from './components/RFCarousel';
import eventTracker from '../../../helpers/eventTracker';
import events from '../events';
import { Arrow } from '../../../styles/common-styles';

const RecycleFundamentals = ({
  rf_lessons,
  windowsWidth,
  setDisplayedContent,
  setRef
}) => {
  const [rfLessonPageIndex, setRFLessonPageIndex] = useState(0);
  const [rfLessonItemIndex, setRfLessonItemIndex] = useState();
  const [showRfLessonDetails, setShowRfLessonDetails] = useState();
  const [itemPerPage, setItemPerPage] = useState(windowsWidth >= 700 ? 3 : 2);

  const learnMoreClickHandler = (index) => {
    setShowRfLessonDetails(true);
    setDisplayedContent('rfLessons');
    setRfLessonItemIndex(index);
    eventTracker(
      events.DZ_HOME_RF_ITEM_TAP,
      { activity_id: rf_lessons[index].activities[0].coachable_id }
    );
    goToTop();
  };

  const goBackHandler = () => {
    setShowRfLessonDetails(false);
    setDisplayedContent();
    eventTracker(events.DZ_RF_BACK_BTN_TAP, '');
    goToTop();
    setRef('RFRef');
  };

  const nextRFHandler = () => {
    setRfLessonItemIndex((prevState) => prevState + 1);
    eventTracker(events.DZ_RF_NEXT_CTA_TAP, '');
    goToTop();
  };

  const previousRFHandler = () => {
    setRfLessonItemIndex((prevState) => prevState - 1);
    goToTop();
  };
  useEffect(() => {
    setItemPerPage(windowsWidth >= 700 ? 3 : 2);
  }, [windowsWidth]);

  useEffect(() => {
    setRFLessonPageIndex(0);
  }, [itemPerPage]);

  return (
    <Container key={rfLessonPageIndex}>

      <Title>
        {showRfLessonDetails && (
          <Arrow background="#fff" onClick={goBackHandler} aria-label="Go back">
            &#8678;
          </Arrow>
        )}
        {showRfLessonDetails
          ? rf_lessons[rfLessonItemIndex].title : _('education.recycling_fundamentals')}
      </Title>

      {showRfLessonDetails ? (
        <RFDetails
          key={rfLessonItemIndex}
          rfLessonItemIndex={rfLessonItemIndex}
          rf_lessons={rf_lessons}
          previousRFHandler={previousRFHandler}
          nextRFHandler={nextRFHandler}
        />
      ) : (
        <RFCarousel
          rfLessonPageIndex={rfLessonPageIndex}
          rf_lessons={rf_lessons}
          itemPerPage={itemPerPage}
          learnMoreClickHandler={learnMoreClickHandler}
          setRFLessonPageIndex={setRFLessonPageIndex}
        />
      )}
    </Container>
  );
};

export default connect(
  (store) => ({
    rf_lessons: store.education.rf_lessons,
    selectedLang: store.config.selectedLang
  })
)(RecycleFundamentals);

const OpacityAnimation = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

const Container = styled.div`
  box-sizing: border-box;
  padding: 10px 0;
  padding-top: 5px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  margin-top: 15px;
  overflow: hidden;
  position: relative;
  animation: ${OpacityAnimation} 0.5s;
`;

const Title = styled.h2`
  display:flex;
  align-items: center;
  font-size: 18px !important;
  color: rgba(64, 64, 64, 1);
  font-weight: 700 !important;
  border-bottom: 2px solid #E7ECEF;
  padding-bottom: 10px !important;
  padding-left: 10px !important;
  margin-top: 10px !important;
`;
